import { useState } from "react";
import { PropsWithChildren } from "react";
import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import { colors } from "../../../theme/colors";

interface Props {
  selected: boolean;
}

const borderRadius = "100px";

const InputContainer = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  borderRadius,
  width: "250px",
  height: "100%",
  marginTop: "30px",
  position: "relative",
}));

const StyledInput = styled("input")(({ theme }) => ({
  border: "none",
  borderRadius,
  height: "100%",
  width: "100%",
  padding: "0",
  boxSizing: "border-box",
  backgroundColor: `black`,
}));

const ButtonContainer = styled("div")(({ theme }) => ({
  display: "flex",
  position: "absolute",
  top: 0,
  right: 0,
  height: "100%",
  width: "100%",
  borderRadius,
}));

const StyledButton = styled(Button)(
  ({ selected }: PropsWithChildren<Props>) => ({
    borderRadius,
    height: "100%",
    width: "50%", // Ajusta a largura dos botões para que eles se ajustem lado a lado
    color: "#fff",
    backgroundColor: selected ? colors.background.error : "black", // Define a cor de fundo com base na seleção
    border: `2px solid black`,
    fontSize: "12px",
    "&:hover": {
      backgroundColor: selected ? colors.background.error : "black",
      // border: `2px solid ${colors.background.error}`,
    },
  })
);

export const PlanInputButtons = () => {
  // let plan = "mensal";
  const [selectedPlan, setSelectedPlan] = useState("mensal");

  const handleClick = (plan: string) => {
    setSelectedPlan(plan);
  };

  return (
    <InputContainer>
      <StyledInput placeholder="" />
      <ButtonContainer>
        <StyledButton
          variant="contained"
          selected={selectedPlan === "mensal"}
          onClick={() => handleClick("mensal")}
        >
          Mensal
        </StyledButton>
        <StyledButton
          variant="contained"
          selected={selectedPlan === "anual"}
          onClick={() => handleClick("anual")}
        >
          Anual
        </StyledButton>
      </ButtonContainer>
    </InputContainer>
  );
};
